(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[239],{

/***/ "teGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Date", function() { return Date; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Date = function Date(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 461.538"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M423.077 38.462h-38.462V0h-38.461v38.462H153.846V0h-38.461v38.462H76.923C34.615 38.462 0 73.077 0 115.385v269.23c0 42.308 34.615 76.923 76.923 76.923h346.154c42.308 0 76.923-34.615 76.923-76.923v-269.23c0-42.308-34.615-76.923-76.923-76.923zm38.461 346.153c0 21.209-17.254 38.462-38.461 38.462H76.923c-21.207 0-38.461-17.253-38.461-38.462V211.538h423.076v173.077zm0-211.538H38.462v-57.692c0-21.208 17.254-38.462 38.461-38.462h38.462v38.462h38.461V76.923h192.308v38.462h38.461V76.923h38.462c21.207 0 38.461 17.254 38.461 38.462v57.692z"
  }));
};

/***/ })

}]);